// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: dUZf5GicyMjS
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  generateOnMutateForSpec,
  generateStateOnChangeProp,
  generateStateOnChangePropForCodeComponents,
  generateStateValueProp,
  initializeCodeComponentStates,
  useDollarState
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import { AntdInput } from "@plasmicpkgs/antd5/skinny/registerInput";
import { inputHelpers as AntdInput_Helpers } from "@plasmicpkgs/antd5/skinny/registerInput";
import Select from "../../Select"; // plasmic-import: r6GO1MnFYJAb/component
import Button from "../../Button"; // plasmic-import: CLyiSGaOpklv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicInviteUserModal.module.css"; // plasmic-import: dUZf5GicyMjS/css

createPlasmicElementProxy;

export const PlasmicInviteUserModal__VariantProps = new Array();

export const PlasmicInviteUserModal__ArgProps = new Array();

const $$ = {};

function PlasmicInviteUserModal__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  const stateSpecs = React.useMemo(
    () => [
      {
        path: "emailInput.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined,
        onMutate: generateOnMutateForSpec("value", AntdInput_Helpers)
      },
      {
        path: "select.value",
        type: "private",
        variableType: "text",
        initFunc: ({ $props, $state, $queries, $ctx }) => undefined
      }
    ],

    [$props, $ctx, $refs]
  );
  const $state = useDollarState(stateSpecs, {
    $props,
    $ctx,
    $queries: {},
    $refs
  });
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div className={classNames(projectcss.all, sty.freeBox__ujiN)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__yZwx
          )}
        >
          <React.Fragment>
            <span
              className={"plasmic_default__all plasmic_default__span"}
              style={{ fontWeight: 500 }}
            >
              {"Email"}
            </span>
          </React.Fragment>
        </div>
      </div>
      <div className={classNames(projectcss.all, sty.freeBox___71Wqv)}>
        {(() => {
          const child$Props = {
            className: classNames("__wab_instance", sty.emailInput),
            onChange: async (...eventArgs) => {
              generateStateOnChangePropForCodeComponents(
                $state,
                "value",
                ["emailInput", "value"],
                AntdInput_Helpers
              ).apply(null, eventArgs);
            },
            placeholder: "Enter Email",
            value: generateStateValueProp($state, ["emailInput", "value"])
          };
          initializeCodeComponentStates(
            $state,
            [
              {
                name: "value",
                plasmicStateName: "emailInput.value"
              }
            ],

            [],
            AntdInput_Helpers ?? {},
            child$Props
          );
          return (
            <AntdInput
              data-plasmic-name={"emailInput"}
              data-plasmic-override={overrides.emailInput}
              {...child$Props}
            />
          );
        })()}
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__e7Ruk)}>
        <div
          className={classNames(
            projectcss.all,
            projectcss.__wab_text,
            sty.text__qlKZt
          )}
        >
          <React.Fragment>
            <span
              className={"plasmic_default__all plasmic_default__span"}
              style={{ fontWeight: 500 }}
            >
              {"Select Role"}
            </span>
            <React.Fragment>
              {" (or add new role and select your permissions)"}
            </React.Fragment>
          </React.Fragment>
        </div>
      </div>
      <div
        data-plasmic-name={"selectRoleStack"}
        data-plasmic-override={overrides.selectRoleStack}
        className={classNames(projectcss.all, sty.selectRoleStack)}
      >
        <Select
          data-plasmic-name={"select"}
          data-plasmic-override={overrides.select}
          className={classNames("__wab_instance", sty.select)}
          onChange={async (...eventArgs) => {
            ((...eventArgs) => {
              generateStateOnChangeProp($state, ["select", "value"])(
                eventArgs[0]
              );
            }).apply(null, eventArgs);
            if (
              eventArgs.length > 1 &&
              eventArgs[1] &&
              eventArgs[1]._plasmic_state_init_
            ) {
              return;
            }
          }}
          options={[
            { value: "option1", label: "Option 1" },
            { value: "option2", label: "Option 2" }
          ]}
          value={generateStateValueProp($state, ["select", "value"])}
        />
      </div>
      <div className={classNames(projectcss.all, sty.freeBox__wmHgB)}>
        <Button
          data-plasmic-name={"sendInviteBtn"}
          data-plasmic-override={overrides.sendInviteBtn}
          className={classNames("__wab_instance", sty.sendInviteBtn)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___1Jwbv
            )}
          >
            {"Send invite"}
          </div>
        </Button>
        <Button
          data-plasmic-name={"addRoleBtn"}
          data-plasmic-override={overrides.addRoleBtn}
          className={classNames("__wab_instance", sty.addRoleBtn)}
        >
          <div
            className={classNames(
              projectcss.all,
              projectcss.__wab_text,
              sty.text___2BUdg
            )}
          >
            {"Add Role"}
          </div>
        </Button>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "emailInput",
    "selectRoleStack",
    "select",
    "sendInviteBtn",
    "addRoleBtn"
  ],

  emailInput: ["emailInput"],
  selectRoleStack: ["selectRoleStack", "select"],
  select: ["select"],
  sendInviteBtn: ["sendInviteBtn"],
  addRoleBtn: ["addRoleBtn"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInviteUserModal__ArgProps,
          internalVariantPropNames: PlasmicInviteUserModal__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInviteUserModal__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInviteUserModal";
  } else {
    func.displayName = `PlasmicInviteUserModal.${nodeName}`;
  }
  return func;
}

export const PlasmicInviteUserModal = Object.assign(
  // Top-level PlasmicInviteUserModal renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    emailInput: makeNodeComponent("emailInput"),
    selectRoleStack: makeNodeComponent("selectRoleStack"),
    select: makeNodeComponent("select"),
    sendInviteBtn: makeNodeComponent("sendInviteBtn"),
    addRoleBtn: makeNodeComponent("addRoleBtn"),
    // Metadata about props expected for PlasmicInviteUserModal
    internalVariantProps: PlasmicInviteUserModal__VariantProps,
    internalArgProps: PlasmicInviteUserModal__ArgProps
  }
);

export default PlasmicInviteUserModal;
/* prettier-ignore-end */
